// angular
//     .module("HeroPRO")
//     .controller("FundingDocumentsController", fundingDocumentsController);

import _ from 'lodash';
import './fundingDocuments.scss';

/* @ngInject */
export default function fundingDocumentsController($scope, $uibModal, DocumentLink, $q, HPStateMachineConfig, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, HPPipelineStages, HPConditionTypes) {
    const vm = this;
    vm.financialDocumentsCollapsed = true;
    vm.isDocumentsSectionVisible = false;
    vm.currentPipelineStageName = '';
    vm.isLoaded = false;
    vm.invalidDocuments = [];
    vm.financialDocuments = [];
    vm.otherDocuments = [];
    vm.eSignDocuments = [];
    vm.HPConditionTypes = HPConditionTypes;

    init();

    /*= =======================================
     =            Public Functions            =
     ======================================== */
    vm.getOtherDocumentsLink = function (document) {
        if (document.LatestAttachment !== undefined) {
            return DocumentLink.getOtherDocumentsLink(document);
        }
    };

    vm.getFinancialDocumentsLink = function (document) {
        return DocumentLink.getFinancialDocumentsLink(document);
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
     =            Private Functions            =
     ======================================== */
    function init() {
        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(() => {
            vm.invalidDocuments = FRDocumentsFactory.getInvalidDocuments();
            vm.financialDocuments = FRDocumentsFactory.getFinancialDocuments();
            vm.otherDocuments = FRDocumentsFactory.getOtherDocuments();
            vm.eSignDocuments = FRDocumentsFactory.getESignDocuments();
            vm.currentPipelineStageName = _.find(HPPipelineStages, pipelineStage => pipelineStage.pipelineStageId === FRInformationFactory.getStateMachineData().PipelineStageId).name;

            // Set a flag to hide the documents section when there are no documents available
            vm.isDocumentsSectionVisible = vm.invalidDocuments.length > 0 || vm.financialDocuments.length > 0 || vm.otherDocuments.length > 0 || vm.eSignDocuments.length > 0;
            vm.isLoaded = true;
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/fundingDocumentsController.js